import PropTypes from 'prop-types'
import { StoreTradingSchedule } from '../shared/helpers/parse-opening-hours/types'
import { ImageTypes } from './images'

export interface TradingHours {
  date: string
  openingTime: string
  closingTime: string
  closed: boolean
  description: string
}

export interface OpeningHours {
  day: string
  openTime: string
  closeTime: string
  closed: boolean
}

export interface TradingHour {
  date: string
  openingTime: string
  closingTime: string
  closed: boolean
  description: string
  hourStatus: HourStatus
}

export enum HourStatus {
  Normal = 'normal',
  Overnight = 'overnight',
  Multiple = 'multiple',
  Closed = 'closed',
}

export interface RawOpeningHours {
  tradingHours: TradingHour[]
  timeZone: string
  features: string[] | undefined
}

export const tradingHoursPropType = PropTypes.shape({
  date: PropTypes.string.isRequired,
  openingTime: PropTypes.string.isRequired,
  closingTime: PropTypes.string.isRequired,
  closed: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
})

interface Store {
  title: string
  storeTradingSchedule: StoreTradingSchedule
}

export interface Service {
  store: Store
  sys: Sys
  slug: string
}

export interface Centre {
  conciergeService?: Service
  title: string
  physicalAddress: string
  suburb: string
  state: string
  postcode: string
  latitude: number
  longitude: number
  telephoneNumber: string
  tradingHours: TradingHours[]
  timeZone: string
  emailAddress: string
  features: string[]
  sys: Sys
  status: string
  country: string
  slug: string
  facebook: string
  twitter: string
  instagram: string
  jibestreamV4VenueId: number
}

export const centrePropType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  physicalAddress: PropTypes.string.isRequired,
  suburb: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  postcode: PropTypes.string.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  telephoneNumber: PropTypes.string.isRequired,
  tradingHours: PropTypes.arrayOf(tradingHoursPropType.isRequired).isRequired,
  timeZone: PropTypes.string.isRequired,
})

export interface Sys {
  id: string
}

export interface Image {
  title: string
  description: string
  url: string
}

export interface EntryImageSet {
  [ImageTypes.Master]?: Image
  [ImageTypes.Standard]?: Image
  [ImageTypes.Square]?: Image
  description: string
}

export enum DisplayMode {
  Feature = 'Feature',
  UtilityPanel = 'UtilityPanel',
  FlipFlop = 'Flip Flop',
  HalfHalfWithImage = 'Half Half (With Image)',
  HalfHalfTextOnly = 'Half Half (Text Only)',
  FullWidthWithImage = 'Full Width (With Image)',
  FullWidthTextOnly = 'Full Width (Text Only)',
  Accordion = 'Accordion',
  FeaturedContent = 'Featured Content',
  Deck = 'Deck',
  PageHeading = 'Page Heading',
  SectionHeading = 'Section Heading',
  Promotion = 'Promotion',
  FilteredCardList = 'FilteredCardList',
  SocialFeed = 'SocialFeed',
  CentreReviews = 'CentreReviews',
  News = 'News',
  Spotlight = 'Spotlight',
}

// TODO this is just the subsets of AutomatedCollection and
// ServicesArticleSummary the requests I'm concerned with are expected to
// generate, needs to be expanded for use elsewhere

interface ServicesArticleSummary {
  title?: string
  shortDescription?: string
  slug?: string
  heroImageSet?: EntryImageSet
}

export interface AutomatedCollection {
  contentTypes?: string[]
  displayMode?: DisplayMode
  contentLimit?: number
  title?: string
  relatedContent?: string
  topics?: Sys[]
  experiences?: Sys[]
  retailCategories?: Sys[]
  entries: ServicesArticleSummary[]
}
